// tslint:disable:max-line-length

import React from 'react';

export const UtilityBatch = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M14.5,7.5v7h-7v-2h5v-5H14.5z M11.5,4.5v7h-7v-2h5v-5H11.5z M8.5,1.5v7h-7v-7H8.5z" />
    </svg>
  );
};
